<div
  *ngIf="control"
  class="wrap"
  [class.invalid]="control.invalid && control.touched"
  [class.disabled]="control.disabled"
>
  <div *ngIf="iconName" class="icon">
    <app-svg-icon
      [name]="iconName"
      [color]="
        control.invalid && control.touched
          ? 'color-state-error'
          : 'color-neutral-4'
      "
    ></app-svg-icon>
  </div>
  <div class="content" [class.with-icon]="iconName">
    <div *ngIf="label" class="label">
      {{ label }}
      <span *ngIf="isMarkedAsRequired" class="required-mark">*</span>
    </div>
    <input
      [type]="inputType"
      [placeholder]="placeholder"
      [formControl]="control"
      class="input"
    />
  </div>
</div>
